import { render, staticRenderFns } from "./observe-detail.vue?vue&type=template&id=bb7c7cf6&scoped=true"
import script from "./observe-detail.vue?vue&type=script&lang=js"
export * from "./observe-detail.vue?vue&type=script&lang=js"
import style0 from "./observe-detail.vue?vue&type=style&index=0&id=bb7c7cf6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb7c7cf6",
  null
  
)

export default component.exports